import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Orbit as OrbitIcon } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, tenant_slug: localStorage.getItem("orbit_tenant") || null });
      setSent(true);
      toast.success("Si le compte existe, un email a été envoyé.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl bg-indigo-600 grid place-items-center text-white"><OrbitIcon className="w-5 h-5"/></div>
          <div className="font-display font-bold text-xl">ORBIT</div>
        </div>
        <h2 className="font-display text-3xl font-bold text-slate-900">Mot de passe oublié</h2>
        <p className="text-slate-500 mt-2">Recevez un lien de réinitialisation par email.</p>
        {sent ? (
          <div data-testid="forgot-success" className="mt-6 p-4 rounded-xl bg-emerald-50 border border-emerald-100 text-emerald-800 text-sm">
            Vérifiez votre boîte de réception. Le lien est valide 1 heure.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input
              data-testid="forgot-email"
              type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
              placeholder="vous@orbit.fr"
              className="w-full px-4 py-3 rounded-xl border border-slate-200 bg-white text-sm outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-400"
            />
            <button data-testid="forgot-submit" disabled={loading} className="w-full py-3 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white font-semibold disabled:opacity-60">
              {loading ? "Envoi…" : "Envoyer le lien"}
            </button>
          </form>
        )}
        <Link to="/login" data-testid="forgot-back" className="block mt-6 text-center text-sm text-indigo-600 hover:underline">Retour à la connexion</Link>
      </div>
    </div>
  );
}
